import type { IconGlyph } from '../icon';

/**
 * Tractie `batch-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/batch-thick.jsx`.
 * Verbatim copy of the SVG `d` attributes, 3 paths in source order.
 */
export const iconBatchThick: IconGlyph = {
  name: 'batch-thick',
  path: [
    'M19.5 3h-9C9.67 3 9 3.67 9 4.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5M19 13h-8V5h8z',
    'M8 6h-.5C6.67 6 6 6.67 6 7.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V16H8z',
    'M5 9h-.5C3.67 9 3 9.67 3 10.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V19H5z',
  ],
};
